// Challenges + Hidden Gems + Beach of the Week client
const API = process.env.REACT_APP_BACKEND_URL;
const handle = (r) => r.ok ? r.json() : r.text().then((t) => { throw new Error(t || `${r.status}`); });
const get = (p) => fetch(`${API}${p}`, { credentials: 'include' }).then(handle);
const post = (p, b) => fetch(`${API}${p}`, { method: 'POST', credentials: 'include',
  headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b || {}) }).then(handle);

export const challenges = {
  weekly:    () => get('/api/challenges/weekly'),
  mine:      () => get('/api/me/challenges'),
  claim:     (qid) => post(`/api/me/challenges/${qid}/claim`),
};

export const hiddenGems = {
  list:  () => get('/api/hidden-gems'),
  check: (id) => get(`/api/hidden-gems/${id}`),
};

export const beachOfWeek = () => get('/api/beach-of-week');
